import dupeBusinessClient from "./DupeBusinessClient";

export async function createDRoll(droll) {
    return await dupeBusinessClient.post("/api/v1/d_rolls", droll).catch(error => {
        console.log(error);
    });
}

export async function updateDRoll(drollId, droll) {
    return await dupeBusinessClient.put("/api/v1/d_rolls/" + drollId, droll).catch(error => {
        console.log(error);
    });
}

export async function getDRolls() {
    return await dupeBusinessClient.get("/api/v1/d_rolls").catch(error => {
        console.log(error);
    });
}

export async function getArchivedDRolls() {
    return await dupeBusinessClient.get("/api/v1/d_rolls/archived").catch(error => {
        console.log(error);
    });
}

export async function getDRollByName(drollSlug) {
    return await dupeBusinessClient.get("/api/v1/d_rolls/" + drollSlug).catch(error => {
        console.log(error);
    });
}

export async function getDRollSubmissions(drollId) {
    return await dupeBusinessClient.get("/api/v1/d_rolls/" + drollId + "/submissions").catch(error => {
        console.log(error);
    });
}

export async function getDRollContent(drollId) {
    return await dupeBusinessClient.get("/api/v1/d_rolls/" + drollId + "/content").catch(error => {
        console.log(error);
    });
}

export async function approveDRollContent(drollId, contentIds) {
    return await dupeBusinessClient.post("/api/v1/d_rolls/" + drollId + "/content/approve", {
        contentIds: contentIds,
    }).catch(error => {
        console.log(error);
    });
}

export async function denyDRollContent(drollId, contentIds) {
    return await dupeBusinessClient.post("/api/v1/d_rolls/" + drollId + "/content/deny", {
        contentIds: contentIds,
    }).catch(error => {
        console.log(error);
    });
}

export async function approveDRollSubmission(drollId, submissionId) {
    return await dupeBusinessClient.post("/api/v1/d_rolls/" + drollId + "/submissions/" + submissionId + "/approve").catch(error => {
        console.log(error);
    });
}

export async function denyDRollSubmission(drollId, submissionId) {
    return await dupeBusinessClient.post("/api/v1/d_rolls/" + drollId + "/submissions/" + submissionId + "/deny").catch(error => {
        console.log(error);
    });
}

export async function updateDRollSubmissionPayment(drollId, submissionId, paymentAmount) {
    return await dupeBusinessClient.put("/api/v1/d_rolls/" + drollId + "/submissions/" + submissionId + "/payment", {
        amount: paymentAmount
    }).catch(error => {
        console.log(error);
    });
}

export async function createDRollImage(drollId, request) {
    return await dupeBusinessClient.post("/api/v1/d_rolls/" + drollId + "/image", request, { 
        headers: {'Content-Type': 'multipart/form-data'}
    }).catch(error => {
        console.log(error);
    });
}

export async function archiveDRoll(drollId) {
    return await dupeBusinessClient.delete("/api/v1/businesses/d_rolls/" + drollId).catch(error => {
        console.log(error);
    });
}

export async function restoreDRoll(drollId) {
    return await dupeBusinessClient.post("/api/v1/businesses/d_rolls/" + drollId + "/restore").catch(error => {
        console.log(error);
    });
}

export async function getDRollSlug(drollId) {
    return await dupeBusinessClient.get("/api/v1/d_rolls/" + drollId + "/slug").catch(error => {
        console.log(error);
    });
}

export async function updateDRollOpenEnrollment(request) {
    return await dupeBusinessClient.post("/api/v1/d_rolls/enrollment", request).catch(error => {
        console.log(error);
    });
} 